import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { DialogHelper } from "../core/util/dialogHelper";
import { EntityParts } from "../parts/parts";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class EditFieldApp extends React.Component<EditFieldProps, EditFieldState> {
    common = new AppHelper();
    private tableName: string;
    private sheet: Sheet;
    translations: StringKeyDictionary<string>;
    dataTableVisible: boolean = true;
    selectionTypReadonly: boolean = false;
    showDataType: boolean = true;
    showMandatory: boolean = true;
    showInitialField: boolean = true;

    constructor(props: EditFieldProps) {
        super(props);
        





        this.setOtherStuff();
        this.tableName = props.entity.TableName;
        this.common.enableHooks = true;
        this.common.init(this);
        this.props.context.translations = this.translations;
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.state = {
            lookUpColumns: [],
            dataTypeLocked: false,
            oldEntity: null
        }
    }

    private lockDataType = (dataType: string, length: number = null) => {
        const permanentDataTypes = ["varchar", "nvarchar"];
        this.setState({ dataTypeLocked: true }, () => {
            if (!this.props.entity.IsNew) {
                length = this.state.oldEntity.MaxLenght;
                if (permanentDataTypes.indexOf(dataType) > -1) {
                    dataType = this.state.oldEntity.DataType;
                }
            }
            this.handleFieldChange({ model: "entity.DataType" }, dataType);
            this.handleFieldChange({ model: "entity.MaxLenght" }, length);
            this.sheet.trigger(SheetEventType.Custom, { cmd: "lockDataType", dataType: dataType, lenght: length });
        })
    }

    private unlockDataType = () => {
        this.setState({ dataTypeLocked: false }, () => {
            this.sheet.trigger(SheetEventType.Custom, { cmd: "unlockDataType" });
        })
    }

    private validate = async (): Promise<boolean> => {
        if (this.common.validate()) {
            const columnNameOk = (!this.props.entity.IsNew) || (this.validateColumnName(this.props.entity.ColumnName) && (this.props.entity.ColumnName.length > (this.props.entity.TableName.length + 1)));
            if (!columnNameOk) {
                NotificationHelper.showErrorMessage(this.translations["WebCRM.EditIndividualFields.CheckColumnName"]);
            }
            const dataTableNameOk = Helper.isNullOrEmpty(this.props.entity.DataTable) || this.props.entity.SelectionType == SelectionType.StupidSQL || await this.doesTableExists(this.props.entity.DataTable);
            if (!dataTableNameOk) {
                NotificationHelper.showErrorMessage(this.translations["WebCRM.EditIndividualFields.CheckDataTable"]);
            }

            let sqlOk = true;
            if (this.props.entity.SelectionType == SelectionType.StupidSQL) {
                const [gruppe, zaehler] = (this.props.entity.DataTable ?? "").split(";");
                if (!Helper.isNumber(gruppe) || !Helper.isNumber(zaehler) || Helper.isNullOrEmpty(this.state.query)) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("InfoTool.NoSqlDefined"));
                    sqlOk = false;
                }
            }




            return (columnNameOk && dataTableNameOk && sqlOk);
        } else {
            return false;
        }
    }

    private validateColumnName = (value: string) => {
        return (value.substr(0, this.tableName.length + 1) === (this.tableName + "_"));
    }

    private doesTableExists = async (tableName: string) => {
        const result = await HTTPService.get<JsonResultClass<boolean>>(`EditIndividualFields/CheckIfTableExist?tableName=${tableName}`);
        return result.Code == 0 && result.Data;
    }

    save = async (closeAfterSave) => {
        const isOK = await this.validate();
        if (isOK) {
            //const result = await HTTPService.post<JsonResultClass<EntityParts>>("EditIndividualFields/Save", { field: this.props.entity });

            const [result, _] = await Promise.all([HTTPService.post<JsonResultClass<EntityParts>>("EditIndividualFields/Save", { field: this.props.entity }), this.saveQuery()])

            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(result.Message);
                this.setState({ oldEntity: this.props.entity });
            } else {
                NotificationHelper.showErrorMessage(result.Message);
                this.setState({});
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }
    }

    private saveQuery = () => {
        return new Promise<JsonResultClass>(async (resolve) => {
            const value = this.props.entity.DataTable ?? "";
            const arr = value.split(";");
            if (this.props.entity.SelectionType == SelectionType.StupidSQL && arr.length == 2) {
                const [gruppe, zaehler] = arr;
                const result = await HTTPService.noBusyIndicator().get(`EditIndividualFields/SaveFeldinhaltM?gruppe=${gruppe}&zaehler=${zaehler}&query=${this.state.query}`);
                resolve(result);
            } else {
                resolve({ Code: 0, AdditionalData: {}, Data: null, Id: null, Message: null });
            }
        });
    }


    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.DataType":
            case "entity.MaxLenght":
                break;
            case "entity.ColumnName":
                value = (value as string).toUpperCase();
                if (!(this.validateColumnName(value))) {
                    value = this.tableName + "_";
                }
                break;
            case "entity.DataTable":
                this.setState({ lookUpColumns: dataItem.columns, query: dataItem.query }, () => {
                    if (this.props.entity.SelectionType == SelectionType.MultiLangDropDownList)
                        this.lockDataTypeByTableDefinition(this.props.entity.SelectionType);
                });
                break;
            case "entity.SelectionType":
                switch (value as SelectionType) {
                    case SelectionType.MultiLangDropDownList:
                        this.lockDataTypeByTableDefinition(value);
                        break;
                    case SelectionType.ComboBox:
                    case SelectionType.DropDownList:
                    case SelectionType.EditBox:
                        if (!this.props.entity.IsNew) {
                            this.lockDataType(this.state.oldEntity.DataType, this.state.oldEntity.MaxLenght);
                        }
                        else {
                            this.unlockDataType();
                        }
                        if (this.props.entity.SelectionType == SelectionType.EditBox)
                            this.setState({ lookUpColumns: [] });
                        break;
                    case SelectionType.Address:
                    case SelectionType.Machine:
                    case SelectionType.Project:
                        this.lockDataType("nvarchar", 20);
                        break;
                    case SelectionType.Resource:
                        this.lockDataType("nvarchar", 10);
                        break;
                    case SelectionType.Contact:
                    case SelectionType.Ticket:
                        this.lockDataType("int");
                        break;
                    case SelectionType.User:
                        this.lockDataType("nvarchar", 12);
                        break;
                    case SelectionType.StupidSQL:
                        this.lockDataType("bit");
                        break;
                }
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem, () => {
                this.setOtherStuff();
                this.setState({})
            });
    }

    private waitForLookUpTable = () => {
        this.handleFieldChange({ model: "entity.DataType" }, "");
        this.sheet.trigger(SheetEventType.Custom, { cmd: "waitForLookUp" });
    }

    private lockDataTypeByTableDefinition = (selectionType: SelectionType) => {
        if (this.state.lookUpColumns.length > 0) {
            let colName = "nr"
            //if (selectionType == SelectionType.MultiLangDropDownList)
            //    colName = "nr";
            const col = this.state.lookUpColumns.find(f => f.ColumnName.toLowerCase() == colName.toLowerCase());
            if (Helper.hasValue(col)) {
                this.lockDataType(col.DataType, col.MaxLenght);
            } else {
                this.waitForLookUpTable();
            }
        } else {
            this.waitForLookUpTable();
        }
    }

    private setOtherStuff = () => {
        const selectionType = this.props.entity.SelectionType;
        this.dataTableVisible = (selectionType == SelectionType.ComboBox) || (selectionType == SelectionType.DropDownList) || (selectionType == SelectionType.MultiLangDropDownList);
        if (selectionType == SelectionType.StupidSQL) {
            if (!this.props.entity.IsNew) {
                this.selectionTypReadonly = true;
                this.showDataType = false;
                this.showMandatory = false;
                this.showInitialField = false;
            } else {
                this.showDataType = false;
                this.showMandatory = false;
                this.showInitialField = false;
            }
        }
        else {
            this.selectionTypReadonly = false;
            this.showDataType = true;
            this.showMandatory = true;
            this.showInitialField = true;
        }

    }

    componentDidUpdate() {
        this.common.updateSheetTitle(this.props.entity.IsNew ? "" : this.props.entity.ColumnName);
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.entity.IsNew ? "" : this.props.entity.ColumnName);
        this.setState({ oldEntity: JSON.parse(JSON.stringify(this.props.entity)) });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EditFieldProps extends AppBaseProps {
    entity: IndividualField;
    context: EditFieldContext;
}

interface EditFieldState {
    lookUpColumns: ColumnInfo[];
    dataTypeLocked: boolean;
    oldEntity: IndividualField;
    query?: string;
}


interface EditFieldContext extends Context {
    translations?: {}
    isUniCode: boolean;
}
export interface IndividualField extends Entity {
    TableName: string;
    Ordinal: number;
    ColumnName: string;
    DataType: string;
    MaxLenght: number;
    DataTable: string;
    SelectionType: SelectionType;
    Mandatory: boolean;
    Designation: string;
    Translations: [];
    IsPrimaryKey: boolean;
    OrderByField: string;
}

export interface ColumnInfo {
    ColumnName: string;
    DataType: string;
    MaxLenght: number;
}
export enum SelectionType {
    DropDownList = 0,
    ComboBox = 1,
    EditBox = 2,
    MultiLangDropDownList = 3,
    StupidSQL = 5,
    Address = 100,
    Machine = 110,
    Project = 120,
    Resource = 130,
    Contact = 140,
    Ticket = 150,
    User = 160
}